import Vue from "vue";
import { getQueryString } from "@/util/extends/cookieExpand";
import { i18n, setup } from "@/locales";

let localLang = localStorage.getItem("localeLanguage");
let lang = getQueryString("ui")
  ? getQueryString("ui").toLowerCase()
  : localLang
    ? localLang.toLowerCase()
    : "cn";
setup(lang);
const vueIn18 = new Vue({ i18n });
//系统列表
export const platformType = [
  { label: "UCENTER", value: "UCENTER" },
  { label: "ASSP", value: "ASSP" },
  { label: "MTDS", value: "MTDS" },
  { label: "WSP", value: "WSP" },
];

//组织类型
export const orgType = [
  { label: "欧派", value: "OPPEIN" },
  { label: "代理商", value: "AGENT" },
  { label: "第三方", value: "OTHER" },
];

//角色来源类型
export const roleType = [
  { label: "职位", value: "POSITION" },
  // {label:'部门',value:'DEPARTMENT'},
].concat(platformType);

//系统日志类型
export const systemLogType = [
  { label: "登录", value: "LOGIN" },
  { label: "查看", value: "VIEW" },
  { label: "修改", value: "UPDATE" },
  { label: "新增", value: "ADD" },
  { label: "删除", value: "DEL" },
  { label: "其他", value: "OTHER" },
  // {label:'无效请求',value:''},
];

//品牌
export const brand = [
  { value: "brand_outu", label: vueIn18.$t("projectOrder.outu") },
  { value: "brand_oppein", label: vueIn18.$t("projectOrder.oppein") }, //"欧派"
  { value: "brand_oboli", label: vueIn18.$t("projectOrder.oboli") },
  { value: "brand_oboni", label: vueIn18.$t("projectOrder.oboni") },
  { value: "brand_baunis", label: vueIn18.$t("projectOrder.baunis") },
  {
    value: "brand_baunis_starhomes",
    label: vueIn18.$t("projectOrder.baunisStarhomes"),
  },
  { value: "brand_owell", label: vueIn18.$t("projectOrder.owell") },
  { value: "brand_miform", label: vueIn18.$t("projectOrder.miform") },
  { value: "brand_starhomes", label: vueIn18.$t("projectOrder.starhomes") },
  { value: "brand_fitzcarl", label: vueIn18.$t("projectOrder.fitzcarl") },
  { value: "brand_oboladi", label: vueIn18.$t("projectOrder.oboladi") },
  { value: "brand_enoppein", label: vueIn18.$t("projectOrder.enoppein") },
  { value: "brand_obbao", label: vueIn18.$t("projectOrder.obbao") },
  { value: "brand_owell", label: vueIn18.$t("projectOrder.owell") },
  { value: "brand_oppein_zhina", label: vueIn18.$t("projectOrder.oppeinZhina") },
];

// 更新品牌字典（原地修改数组，确保所有引用处同步更新）
export function updateBrand(newData) {
  brand.splice(0, brand.length, ...newData);
  console.log("brand", brand);
}

//品类
export const category = [
  { value: "category_chugui", label: vueIn18.$t("projectOrder.cabinet") },
  { value: "category_weiyu", label: vueIn18.$t("projectOrder.weiyu") },
  { value: "category_yigui", label: vueIn18.$t("projectOrder.wardrobe") },
  { value: "category_mumen", label: vueIn18.$t("projectOrder.mumen") },
  { value: "category_qiangshi", label: vueIn18.$t("projectOrder.qiangshi") },
  { value: "category_bigFamily", label: vueIn18.$t("projectOrder.dajiaju") },
  {
    value: "category_jinshumenchuang",
    label: vueIn18.$t("projectOrder.jinshumenchuang"),
  },
  { value: "category_shangchu", label: vueIn18.$t("projectOrder.shangchu") },
  {
    value: "category_zhuangjiamen",
    label: vueIn18.$t("projectOrder.zhuangjiamen"),
  },
  { value: "category_bancai", label: vueIn18.$t("projectOrder.bancai") },
  // {value:'category_bigFamily',label:"大家居配套"},
  {
    value: "category_zhucaijicheng",
    label: vueIn18.$t("projectOrder.zhucaijicheng"),
  },
  { value: "category_youcai", label: vueIn18.$t("projectOrder.youcai") },
  { value: "category_zhuangxiu", label: vueIn18.$t("projectOrder.zhuangxiu") },
  {
    value: "category_zhinengjiaju",
    label: vueIn18.$t("projectOrder.zhinengjiaju"),
  },
];

// 更新品类字典（原地修改数组，确保所有引用处同步更新）
export function updateCategory(newData) {
  category.splice(0, category.length, ...newData);
  console.log("category", category);
}

//部门类型
export const departType = [
  { value: "1", label: "欧派公司" },
  { value: "2", label: "商场" },
  { value: "3", label: "门店" },
  { value: "4", label: "部门" },
];
//表达式
export const expression = [
  { value: "=", label: "=" },
  { value: "=<", label: "=<" },
  { value: "like", label: "like" },
  { value: "in", label: "in" },
  { value: "all", label: "all" },
];
//表达式标记
export const depatTag = [
  { value: "and", label: "and" },
  { value: "or", label: "or" },
];
//维度名称
export const vdoingName = [
  { value: "region_id", label: "区域" },
  { value: "department_id", label: "部门" },
  { value: "position_id", label: "职位" },
];

export const productOrderStatus = [
  {
    value: "2000",
    label: vueIn18.$t("projectOrder.notCreated"),
    code: "ORDER_NOT_YET",
  },
  {
    value: "2001",
    label: vueIn18.$t("projectOrder.creating"),
    code: "ORDER_CREATEING",
  },
  {
    value: "2002",
    label: vueIn18.$t("projectOrder.createdSuccessfully"),
    code: "ORDER_CREATE_SUCCESS",
  },
  {
    value: "2003",
    label: vueIn18.$t("projectOrder.creationFailed"),
    code: " ORDER_CREATE_FAIL",
  },
  {
    value: "2004",
    label: vueIn18.$t("projectOrder.designFileProcessing"),
    code: "DESIGN_FILE_HANDLING",
  },
  {
    value: "2005",
    label: vueIn18.$t("projectOrder.successfullyDesignFiles"),
    code: "DESIGN_FILE_HANDLE_SUCCESS",
  },
  {
    value: "2006",
    label: vueIn18.$t("projectOrder.designFileFailed"),
    code: "DESIGN_FILE_HANDLE_FAIL",
  },
];
export const installOptions = [
  { label: "裸盆发商场", value: "upper_basin" },
  { label: "盆装台面发商场", value: "lower_basin" },
];



// WEBPACK FOOTER //
// ./src/util/dict.js